import React, { useEffect } from "react";
import { toast } from "react-toastify";

import { Stack } from "@mui/material";
import { DebtSettings, MeasureDataValidation } from "components/Account-settings";
import { AsyncContentMui } from "components/Async-content/AsyncContentMui";
import { useActionHook } from "hooks";
import { useAccountSelector, useDealActions } from "store";

export const AccountSettings: React.FC = () => {
  const { getAccountSettingsAction, updateAccountSettingsAction } = useDealActions();
  const { validation_panel } = useAccountSelector() || {};

  const { data, loading, action: getSettings } = useActionHook(getAccountSettingsAction);
  const { action: updateSettings, loading: updating } = useActionHook(updateAccountSettingsAction, {
    onSuccess: () => {
      toast.success("Settings updated successfully");
    }
  });

  useEffect(() => {
    getSettings();
  }, []);

  return (
    <AsyncContentMui spinnerProps={{ size: 100 }} isLoading={loading}>
      <Stack sx={{ flexGrow: 1, gap: "20px" }}>
        <DebtSettings
          initialState={{
            periodicLockEnabled: !!(data?.lock_day && data?.lock_frequency),
            lock_day: data?.lock_day || 1,
            lock_frequency: (data?.lock_frequency || "monthly") as "monthly" | "quarterly" | "yearly",
            debtReminderEnabled: !!(data?.debt_reminder_days !== null && data?.debt_reminder_days !== undefined),
            debt_reminder_days: data?.debt_reminder_days || 7,
            debt_reminder_users: data?.debt_reminder_users || []
          }}
          updating={updating}
          updateSettings={updateSettings}
        />
        {validation_panel && (
          <MeasureDataValidation
            rules={
              data?.validation_settings?.rules?.map((item, index) => ({
                id: index + 1,
                ...item
              })) || []
            }
            message={data?.validation_settings?.message || null}
            updating={updating}
            updateSettings={updateSettings}
          />
        )}
      </Stack>
    </AsyncContentMui>
  );
};
